var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVolang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.99995C2 8.78787 2.15519 9.56808 2.45672 10.296C2.75824 11.024 3.2002 11.6854 3.75734 12.2425C4.31449 12.7997 4.97592 13.2416 5.70387 13.5432C6.43181 13.8447 7.21202 13.9999 7.99995 13.9999C8.78787 13.9999 9.56808 13.8447 10.296 13.5432C11.024 13.2416 11.6854 12.7997 12.2425 12.2425C12.7997 11.6854 13.2416 11.024 13.5432 10.296C13.8447 9.56808 13.9999 8.78787 13.9999 7.99995C13.9999 7.21202 13.8447 6.43181 13.5432 5.70387C13.2416 4.97592 12.7997 4.31449 12.2425 3.75734C11.6854 3.2002 11.024 2.75824 10.296 2.45672C9.56808 2.15519 8.78787 2 7.99995 2C7.21202 2 6.43181 2.15519 5.70387 2.45672C4.97592 2.75824 4.31449 3.2002 3.75734 3.75734C3.2002 4.31449 2.75824 4.97592 2.45672 5.70387C2.15519 6.43181 2 7.21202 2 7.99995Z",
    stroke: "#3AB54A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66646 7.9997C6.66646 8.35332 6.80694 8.69246 7.05698 8.9425C7.30703 9.19255 7.64616 9.33302 7.99978 9.33302M6.66646 7.9997C6.66646 7.64608 6.80694 7.30695 7.05698 7.0569C7.30703 6.80686 7.64616 6.66638 7.99978 6.66638C8.3534 6.66638 8.69254 6.80686 8.94258 7.0569C9.19263 7.30695 9.3331 7.64608 9.3331 7.9997M6.66646 7.9997L2.1665 6.66638M7.99978 9.33302C8.3534 9.33302 8.69254 9.19255 8.94258 8.9425C9.19263 8.69246 9.3331 8.35332 9.3331 7.9997M7.99978 9.33302V13.9996M9.3331 7.9997L13.8331 6.66638",
    stroke: "#3AB54A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVolang);
export default __webpack_public_path__ + "static/media/ic-volang.0d21ac175a18bda57040687880b24879.svg";
export { ForwardRef as ReactComponent };